import React from "react";

const Section4 = () => {
  return (
    <div className="container-1280 xl:min-w-[70%] lg:min-w-[90%] w-[95%] m-auto">
      <div className="grid grid-cols-1 m-auto md:grid-cols-2 md:p-5 place-items-center">
        <div className="h-auto lg:w-[70%] w-auto pt-8 pb-8">
          <img src="../../../assets/tailoredWebDesSol-WebDevPage.png" alt="" />
        </div>
        <div className="w-auto h-[100%] flex flex-col gap-4 justify-center ">
          <h2 className="text-[26px] md:text-[30px] font-bold text-red-600 leading-[28px] md:leading-[34px]">
            Tailored Web Design Solutions
          </h2>
          <p className="text-sm text-gray-700">
            Your website is more than just a digital presence—it’s your brand’s
            identity online. At Mean3, we design websites that are as unique as
            your business. Our experienced team combines creativity and
            technical expertise to deliver designs that resonate with your
            audience and enhance your brand's credibility.
          </p>
          <p className="text-sm text-gray-700">
            We use cutting-edge tools and strategies to ensure your message
            reaches the right people while creating an unforgettable user
            experience. Whether it’s increasing engagement or boosting
            conversions, we craft solutions that deliver measurable results.
          </p>
        </div>
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </div>
  );
};

export default Section4;
